import Image from 'next/image'
import Head from 'next/head'
import axios from 'axios'
import Cookies from 'js-cookie'
import { useState } from 'react'
import { useAppContext } from 'contexts/app_context'

import AppHeader from 'components/app_header'
import AppFooter from 'components/app_footer'
import ModalMessage from 'components/modals/modal_message'
import ModalJoinOuting from 'components/modals/modal_join_outing'

import styles from 'styles/support.module.scss'
import { apiResponseErrorHandler } from 'utils/apiHandler'
import { TeamGamesMetaDescription, TeamGamesOGImagePath } from 'utils/constants'

export const Support = () => {
  const [state, dispatch] = useAppContext()
  const [email, setEmail] = useState('')
  const [code, setCode] = useState('')
  const [issue, setIssue] = useState('')

  const submitRequest = async () => {
    if (!validateForm({ email, issue })) {
      return
    }
    try {
      const jwtToken = Cookies.get('jwtToken')
      await axios.post(
        `${process.env.API_HOST}/support/submit-request`,
        {
          email,
          code,
          issue,
        },
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
          },
        },
      )
      const messagePayload = {
        additional: {
          messageTitle: 'Confirmation',
          message: 'Thanks for using Team Games. We will get back to you within 1 business day.',
          btnClose: 'Return',
        },
      }
      dispatch({
        type: 'SET_ALERT_MESSAGE',
        payload: messagePayload,
      })
      dispatch({ type: 'SHOW_MODAL_MESSAGE', payload: true })
    } catch (error) {
      if (error?.response?.data?.msg === 'Invalid input: {"email":["The email must be a valid email address."]}')
        error.response.data.msg = 'Please enter a valid email address'
      apiResponseErrorHandler({ error, dispatch })
    }
  }

  const validateForm = ({ email, issue }) => {
    let message = ''
    if (!email) {
      message = 'Your Email Address should not be empty'
    }
    if (!issue) {
      message = 'Please enter the Issue you’re having'
    }
    if (message) {
      dispatch({
        type: 'SET_ALERT_MESSAGE',
        payload: message,
      })
      dispatch({ type: 'SHOW_MODAL_MESSAGE', payload: true })
      return false
    }
    return true
  }

  const handleChangeEmail = event => {
    const newEmail = event.target.value.slice(0, 50)
    setEmail(newEmail)
  }

  const handleChangeCode = event => {
    const newCode = event.target.value.slice(0, 25)
    setCode(newCode)
  }

  const handleChangeIssue = event => {
    setIssue(event.target.value)
  }

  return (
    <div className={styles.support_page} id="support_page">
      <Head>
        <title>Contact Us | Team Games</title>
        <link rel="icon" href="/images/modal_logo.png" />
        <meta name="description" content={TeamGamesMetaDescription} />
        <meta name="og:image" content={TeamGamesOGImagePath} />
      </Head>
      <div className={styles.header_section}>
        <AppHeader transparent />
        <div className={styles.header_bg}>
          <div className={styles.header_bg_img}>
            <Image src="/images/contact/header.png" alt="We'd love to hear from you" layout="fill" />
          </div>
        </div>
        <div className={styles.content_bg}>
          <div className={styles.content_bg_img}>
            <Image src="/images/contact/main_bg.png" alt="Contact Page Main Background" layout="fill" />
          </div>
          <div className={styles.support_woman}>
            <Image src="/images/contact/support_woman.png" alt="Support Woman Image" width={635} height={327} />
          </div>
        </div>
      </div>
      <div className={styles.support_container}>
        <div className={styles.support_context}>
          <h1 className={`hero ${styles.title}`}>We'd love to hear from you</h1>
          <div className={`description_large ${styles.description}`}>
            <p>Feel like contacting us? Submit your queries here and we will get back to you as soon as possible.</p>
          </div>
        </div>
        <div className={styles.support_form}>
          <div>
            <h2 className={`heading_2 ${styles.support_title}`}>Contact Us</h2>
          </div>
          <div className={styles.support_label}>Email Address</div>
          <input
            className={styles.support_input}
            type="text"
            placeholder="Enter Your Email"
            value={email}
            onChange={handleChangeEmail}
          />
          <div className={styles.support_label}>Outing URL or Outing code</div>
          <input
            className={styles.support_input}
            type="text"
            placeholder="Enter Outing URL Or Passcode Here"
            value={code}
            onChange={handleChangeCode}
          />
          <div className={styles.support_label}>Describe the Issue you’re having</div>
          <textarea
            className={styles.support_textarea}
            rows={10}
            maxLength={1000}
            placeholder="Description"
            value={issue}
            onChange={handleChangeIssue}
          ></textarea>
          <div className={styles.support_action}>
            {/* <div className={styles.support_action_cancel}>Cancel</div> */}
            <div className={styles.support_action_submit} onClick={submitRequest}>
              Submit
            </div>
          </div>
        </div>
      </div>
      <ModalMessage />
      <ModalJoinOuting />
      <AppFooter />
    </div>
  )
}

export default Support
